// Canvas v2 inspect-mode hover. Reads the DOMQL ref path from a
// forwarded pointer event and writes it to scope for the overlay to
// render from. No DOM probing — the ref is whatever DOMQL already
// attached during render.

export function inspectHover(ev) {
  const scope = this.call('getCanvasScope')
  if (!scope) return
  if (!ev?.target?.ref) {
    scope.hoverLayer = null
    return
  }
  const path = [...ev.target.ref.__ref.path]
  path.splice(0, 8)
  scope.hoverLayer = path.filter((key) => key[0] !== key[0].toLowerCase())
}
